<div class="quote-attachment" (click)="openQuote(message)">
  <i class="fa fa-folder quote-attachment__icon"></i>
  <span class="quote-attachment__name">{{ message.fileName || 'Preventivo' }}</span>
  <i class="fa fa-external-link quote-attachment__arrow"></i>
</div>
